import script from "./suit-crowd.vue?vue&type=script&setup=true&lang=js"
export * from "./suit-crowd.vue?vue&type=script&setup=true&lang=js"

import "./suit-crowd.vue?vue&type=style&index=0&id=bd3e03a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd3e03a0"]])

export default __exports__